export default "__VITE_ASSET__B$LU_D9j__"